import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "store/hook";

const PrivateRoutes = () => {
  const { isLogin } = useAppSelector((state) => state.global);

  // <Outlet />元件以父元件<Route>元素渲染出子元件
  /*
    當 Redux global 
      isLogin 值為 ture 渲染 <Outlet/> 子元件
              值為 false 路由跳轉至 "/userlogin"
  */
  return isLogin ? <Outlet /> : <Navigate to="/userlogin" />;
};

export default PrivateRoutes;
